import { gql } from '@apollo/client';
import appraiserFieldsFragment from '../../AppraiserForm/queries/appraiserFieldsFragment';

const GET_CURRENT_USER_APPRAISER_INFO = gql`
  query GetCurrentUserAppraiserInfo {
    currentAppraiserInfo {
      ...AppraiserFields
    }
  }
  ${appraiserFieldsFragment}
`;

export default GET_CURRENT_USER_APPRAISER_INFO;
